const features = [
  { categoria: 'Spreadsheet', vantagem: 'Organização completa', resultado: 'Compra mais rápida' },
  { categoria: 'Produtos virais', vantagem: 'Atualização diária', resultado: 'Maior economia' },
  { categoria: 'Links verificados', vantagem: 'Menos risco', resultado: 'Mais segurança' },
  { categoria: 'Categorização', vantagem: '14 categorias', resultado: 'Navegação fácil' },
  { categoria: 'Curadoria', vantagem: 'Seleção manual', resultado: 'Qualidade garantida' },
];

export default function FeatureComparison() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12">
          <span className="text-xs md:text-sm text-foreground-400 font-medium tracking-wide uppercase">
            Comparação
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mt-2">
            Por que o HoobuySpreadsheet é{' '}
            <span className="italic text-primary-600">Superior</span>
          </h2>
        </div>

        {/* Feature Table */}
        <div className="overflow-x-auto rounded-xl border border-background-200">
          <table className="w-full text-sm md:text-base">
            <thead>
              <tr className="bg-background-100 text-left">
                <th className="px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Categoria</th>
                <th className="px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Vantagem</th>
                <th className="px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Resultado</th>
              </tr>
            </thead>
            <tbody>
              {features.map((f, i) => (
                <tr key={f.categoria} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-5 py-3.5 font-medium text-foreground-800 whitespace-nowrap">{f.categoria}</td>
                  <td className="px-5 py-3.5 text-foreground-600 whitespace-nowrap">{f.vantagem}</td>
                  <td className="px-5 py-3.5 whitespace-nowrap">
                    <span className="inline-flex items-center gap-1.5 text-accent-600 font-medium">
                      <i className="ri-checkbox-circle-fill text-sm"></i>
                      {f.resultado}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}